import { Component } from 'src/utils';
import dscCard from './../../../images/WBU-DSC-card.jpg';
import houseIcon from './../../../images/house-icon.png';
import template from './savings-club.html';

@Component({
  controllerAs: 'dsc',
  template
})

export default class SavingsClub {
  static $inject = [
    '$scope',
    'orderService',
    '$state',
    '$uibModal',
    'authService',
    '$ngRedux',
    'spinnerService',
    '$window',
    '$stateParams',
    '$cookies',
    'APP'
  ];

  constructor($scope, $order, $state, $uibModal, $auth, $ngRedux, $spinner,$window,$stateParams,$cookies,APP) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.dscCard = dscCard;
    this.houseIcon = houseIcon;
    this.$order = $order;
    this.$state = $state;
    this.agreement = false;
    this.$uibModal = $uibModal;
    this.$auth = $auth;
    this.$stateParams= $stateParams;
    this.$window = $window;
    this.APP = APP;
    this.justOnce = 1;

    if($stateParams.storeName) {
      this.storeName = $stateParams.storeName;
    }
    else {
      this.storeName = this.$auth.getGuestStoreDetail().storeName;
    }
    
    if (this.storeName && !$auth.isLoggedIn()) {
      $auth.getStoreDetail(this.storeName).then(success => {
        let store = {};
      store.storeId = success.data.storeId;
      store.storeName = this.storeName;
      $auth.doGuestLogin(store);
    },
      error => {
        this.$state.go('login');
      }
    );
    } else {
    $spinner.show('appSpinner');
    $window.scrollTo(0, 0);
   let storeName = '';
    if(this.$stateParams.storeName) {
      storeName = this.$stateParams.storeName;
    }
    else {
      if(this.profile && this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      }else if(this.store){
        storeName = this.store.storeName;
       } 
      else {
       storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if(storeName) {
    $order.getCartDetail()
    .finally(() => 
      {
        $spinner.hide('appSpinner');
        this.$auth.getUserProfile();
      });

    } else {
      $spinner.hide('appSpinner');
    }
    }

    $scope.$on('$destroy', disconnect);
    
    // this.isDscAdded = this.isDscAddedinCart();
  }

  mapState(state) {
    return {
      detail: state.order.cartDetail,
      profile: state.auth.profile,
      store: state.auth.storeDetail
    };
  }
  
  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  buyDsc() {
    setTimeout(function() {
      console.log("Executed after 100 milliseconds");
    }, 100);
    if (this.$auth.isGuestLogin()) {
      var msg = 'add this item to cart';
      let cart = null;
      cart = {'quantity': 1, 'itemId': 88888888, 'isDscCard': true,'masterProductId':88888888};
      this.$auth.addtoGuestCart(cart);
      this.$auth.showLoginPopUp(msg);
    }
    else {
      this.$order.buyDscMembership()
    .then(() => {
        this.$auth.getUserProfile();
        // .then(success => {
        //   if(this.profile.store.hasErply){
        //     this.$order.dscPremembership();
        //   }
        // })
        // .catch(error => {
        //   console.log("Profile call failure in dsc membership purchase");
        // });
        this.$state.go('cart'); 
      });
    }
  }

  isDscAddedinCart(){
    if(this.detail.cartItems!=null){
      return this.detail.cartItems.some(function (cartItem) {
        return cartItem.item.storeItemCode === 'C' || cartItem.item.storeItemCode === 'c';
      });
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/order/savings-club/savings-club.js